<template>
  <div class="paperAnalysis" v-loading="loading">
    <el-table :data="paperData" style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div class="container">
            <p v-html="scope.row.name"></p>
            <p v-for="(item, index) in scope.row.options" :key="index">
              {{
                scope.row.type == 3 || scope.row.type == 4
                  ? ""
                  : code[index] + ":"
              }}{{ item.name }}
              <span style="color:#409eff" v-if="item.is_right == 1"
                >(正确选项)</span
              >
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="No." type="index" width="50"></el-table-column>
      <el-table-column label="题型" align="center">
        <template slot-scope="scope">
          <el-link
            :type="
              scope.row.type == 1
                ? 'success'
                : scope.row.type == 2
                ? 'warning'
                : scope.row.type == 3
                ? 'primary'
                : 'info'
            "
          >
            <span v-if="scope.row.type == 1">单选题</span>
            <span v-if="scope.row.type == 2">多选题</span>
            <span v-if="scope.row.type == 3">判断题</span>
            <span v-if="scope.row.type == 4">填空题</span></el-link
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="题目" align="" prop="answered">
          <template slot-scope="scope">
            <span v-html="scope.row.data[0].question.name"></span>
          </template>
        </el-table-column> -->
      <el-table-column label="已答人数" align="center" prop="answer_count">
      </el-table-column>
      <el-table-column label="答题分布" align="center">
        <template slot-scope="scope">
          <span v-show="scope.row.type != 4">
            <span
              class="options"
              v-show="scope.row.type == 1 || scope.row.type == 2"
              v-for="(item, index) in scope.row.options"
              :key="index"
            >
              {{ code[index] }}:
              <span :class="item.total ? 'red' : ''">{{
                item.total ? item.total : 0
              }}</span>
            </span>
            <span
              class="options"
              v-show="scope.row.type == 3"
              v-for="(item, index) in scope.row.options"
              :key="index"
            >
              {{ judge[index] }}:
              <span :class="item.total ? 'red' : ''">{{
                item.total ? item.total : 0
              }}</span></span
            >
          </span>
          <el-link type="success" @click="getChart(scope.row)">饼图</el-link>
        </template>
      </el-table-column>
      <el-table-column label="答题正确比率" align="center">
        <template slot-scope="scope">
          {{
            ((scope.row.right_count / scope.row.answer_count) * 100).toFixed(2)
          }}%
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="chartShow" width="30%">
      <div id="myChart" :style="{ width: '100%', height: '300px' }"></div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "PaperResult",
  data() {
    return {
      loading: true,
      paperData: [],
      code: ["A", "B", "C", "D", "E", "F", "G"],
      judge: ["是", "否"],
      chartShow: false,
    };
  },
  created() {
    let _this = this;
    _this.getData();
  },
  methods: {
    getChart(row) {
      this.chartShow = true;
      let arr = [];
      if (row.type == 4) {
        for (let i in row.select) {
          arr.push({ name: i, value: row.select[i] });
        }
      } else {
        row.options.forEach((item, index) => {
          if (row.type == 1 || row.type == 2) {
            item.option = this.code[index];
          }
          if (row.type == 3) {
            item.option = this.judge[index];
          }
          if (row.type == 4) {
            item.option = item.name;
          }
          arr.push({ name: item.option, value: item.total });
        });
      }
      this.$nextTick(() => {
        this.drawPie(arr);
      });
    },
    drawPie(data) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption({
        title: {
          left: "center",
          top: 20,
          textStyle: {
            color: "#ccc",
          },
        },

        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },

        visualMap: {
          show: false,
          min: 500,
          max: 600,
          inRange: {
            //colorLightness: [0, 1]
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            center: ["50%", "50%"],
            color: ["rgb(131,249,103)", "#a29bfe", "#FE5050", "#74b9ff"],
            data: data.sort(function(a, b) {
              return a.value - b.value;
            }),
            roseType: "radius",

            label: {
              normal: {
                formatter: ["{c|{c}}", "{b|{b}}"].join("\n"),
                rich: {
                  c: {
                    color: "#666",
                    fontSize: 20,
                    fontWeight: "bold",
                    lineHeight: 5,
                  },
                  b: {
                    color: "rgb(98,137,169)",
                    fontSize: 15,
                    height: 40,
                  },
                },
              },
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: "rgb(98,137,169)",
                },
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
            },
            itemStyle: {
              normal: {
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 50,
              },
            },
          },
        ],
      });
    },

    getData() {
      let _this = this;
      _this.loading = true;
      _this.$http
        .get(
          process.env.VUE_APP_URL + "results/question/" + _this.$route.params.id
        )
        .then(function(data) {
          _this.loading = false;
          if (data.data.code == 200) {
            _this.paperData = data.data.data;
            _this.paperData.forEach((item) => {
              for (let i in item.select) {
                item.options.forEach((e) => {
                  if (e.id == i) {
                    e.total = item.select[i];
                  }
                });
              }
            });
          }
        })
        .catch(function(error) {
          _this.loading = false;
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.red {
  color: #f00;
}
.options {
  padding: 0 4px;
}
.container {
  padding: 10px 20px;
}
</style>
